/**
 * The home screen for a sales rep.
 *
 * One path for every partner: the dashboard composes its own sections from the
 * partner's settings, so there is nothing left to branch on. Kept as a function
 * rather than inlining the string so the call sites stay readable and a future
 * change has one place to happen.
 */
export const REP_DASHBOARD_PATH = '/dashboard';

export function dashboardPathFor(): string {
  return REP_DASHBOARD_PATH;
}
